import type { SimEvent } from "../events";
import * as DMath from "../math/det-math";
import type { WorldState } from "../state";
import { steerMissile } from "./homing";
import { tickShip } from "./ships";

/**
 * legacy: WorldObject::tick for every object. Entities spawned during this loop (projectiles)
 * are not ticked until the next tick. Planets and spawn points are static.
 */
export function tickEntities(world: WorldState, events: SimEvent[]): void {
	const count = world.entities.length;
	for (let i = 0; i < count; i++) {
		const e = world.entities[i];
		if (!e) continue;
		switch (e.kind) {
			case "ship":
				tickShip(world, e, events);
				break;
			case "asteroid":
				e.pos.x += e.vel.x;
				e.pos.y += e.vel.y;
				e.angle += e.spin;
				break;
			case "laser":
				e.pos.x += e.vel.x;
				e.pos.y += e.vel.y;
				if (e.rangeLeft !== null) e.rangeLeft -= DMath.hypot(e.vel.x, e.vel.y);
				break;
			case "missile":
				steerMissile(world, e);
				e.pos.x += e.vel.x;
				e.pos.y += e.vel.y;
				break;
			case "planet":
			case "spawnPoint":
			case "pickup":
				break;
		}
	}
}
